import { EmbeddedMetricsLogger } from '@eventbrite/openapi-service';

export const metrics = new EmbeddedMetricsLogger('EventDashboardWebapp');

